
const WalletConnectIcon = 'images/wallet/walletconnect.svg';
const MetamaskIcon = 'images/wallet/metamask.svg';
const CronosConnect = 'images/wallet/deficrypto.svg';


export const wallets = [
  {
    name: 'Metamask',
    icon: MetamaskIcon,
  },
  {
    name: 'Wallet Connect',
    icon: WalletConnectIcon,
  },
  {
    name: 'Crypto.com Wallet',
    icon: CronosConnect,
  }
];

export const CONNECTOR_LOCAL_STORAGE_KEY = 'connector_id';
